import useMutation from '#lib/hooks/use-mutation.js';
import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { getAuthHeader } from '#lib/hooks/use-auth.jsx';
import toast from 'react-hot-toast';

async function sendEmail(data) {
    const authHeaders = await getAuthHeader();
    const response = await fetchAndParse(`${API_URL}/p/sendemail`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(data)
    });
    return response;
}

export function useSendEmail(options) {
    return useMutation({
        mutationFn: sendEmail,
        onSuccess: () => {
            toast.success(_t.global.emailSent());
        },
        onError: (error) => {
            toast.error(_t.global.emailError());
            console.error('Error sending email:', error);
        },
        ...options
    });
}
